import { cn } from '../../helpers/classnames'

export interface JosefFormLabelProps {
  children: React.ReactNode
  htmlFor?: string
  required?: boolean
  className?: string
}

export function JosefFormLabel({
  children,
  htmlFor,
  required = false,
  className = '',
}: JosefFormLabelProps) {
  return (
    <label
      htmlFor={htmlFor}
      className={cn(
        'block text-sm font-medium text-black dark:text-white mb-2',
        className
      )}
    >
      {children}
      {required && <span className="text-red-500 ml-1">*</span>}
    </label>
  )
}

export default JosefFormLabel